import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Account from '@/components/Account'
import AppUser from '@/components/appUser/AppUser'
import AppBuyInfo from '@/components/appUser/appBuyInfo'
import Salesman from '@/components/salesman/Salesman'
import SalesmanStructure from '@/components/salesman/SalesmanStructure'
import ExpertBuyInfo from '@/components/expert/expertBuyInfo'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/account',
      name: 'account',
      component: Account
    },
    {
      path: '/appUser/appUser',
      name: 'appUser',
      component: AppUser
    },
    {
      path: '/appUser/appBuyInfo',
      name: 'appBuyInfo',
      component: AppBuyInfo
    },
    {
      path: '/salesman/salesman',
      name: 'salesman',
      component: Salesman
    },
    {
      path: '/salesman/salesmanStructure',
      name: 'salesmanStructure',
      component: SalesmanStructure
    },
    {
      path: '/expert/expertBuyInfo',
      name: 'expertBuyInfo',
      component: ExpertBuyInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js